import { useEffect, useState } from 'react';
export const useIsElementOffScreen = (ref, isOpen, maxHeight, offSetTop) => {
    const [isOffScreen, setIsOffScreen] = useState();
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const elementPosition = element?.getBoundingClientRect();
        if (!isOpen) {
            return;
        }
        const isOffScreenVerticallyTop = elementPosition?.bottom + maxHeight > window.innerHeight;
        const isOffScreenVeticallyBottom = elementPosition?.top - maxHeight < offSetTop * 10;
        const newIsOffScreen = isOffScreenVerticallyTop && !isOffScreenVeticallyBottom;
        setIsOffScreen(newIsOffScreen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return isOffScreen;
};
//# sourceMappingURL=useElementPosition.js.map